document.addEventListener('DOMContentLoaded', function () {
  const colourPaletteNextStep = document.querySelector('.color-palette-container + .next-step');

  document.querySelectorAll('.variant-accordion-item .accordion-heading').forEach((heading) => {
    heading.addEventListener('click', () => {
      const itemNumber = getItemNumber(heading);
      const variantItem = heading.closest('.variant-accordion-item');
      if (variantItem.classList.contains('active')) return;
      if (
        variantItem.classList.contains('item-1') ||
        document.querySelector(`.variant-accordion-item.completed.item-${itemNumber - 1}`)
      ) {
        variantItem.classList.toggle('active');
        variantItem.classList.remove('completed', 'disabled');
        variantItem.querySelector('.selected-text').innerText = '';
        for (const sibling of document.querySelectorAll('.variant-accordion-item')) {
          if (sibling !== heading.closest('.variant-accordion-item')) {
            sibling.classList.remove('active');
            if (getItemNumber(sibling) > itemNumber) {
              sibling.classList.add('disabled');
              sibling.classList.remove('completed');
              sibling.querySelector('.selected-text').innerText = '';
            }
          }
        }
      }
    });
  });

  document.querySelector('.color-palette-container .colour-input').addEventListener('input', (event) => {
    if (event.target.value) {
      colourPaletteNextStep.removeAttribute('disabled');
    } else {
      colourPaletteNextStep.setAttribute('disabled', '');
    }
  });

  document.querySelectorAll('.color-palette-container .color-item').forEach((colorItem) => {
    colorItem.addEventListener('click', () => {
      colourPaletteNextStep.removeAttribute('disabled');
    });
  });

  document.querySelectorAll('.variant-accordion-item .next-step').forEach((nextStep) => {
    nextStep.addEventListener('click', (event) => {
      const accordionItem = event.target.closest('.variant-accordion-item').classList;
      accordionItem.add('completed');
      accordionItem.remove('active');
      const itemNumber = getItemNumber(event.target);
      document.querySelector(`.variant-accordion-item.item-${Number(itemNumber) + 1}`).classList.add('active');
      document.querySelector(`.variant-accordion-item.item-${Number(itemNumber) + 1}`).classList.remove('disabled');
      event.target.closest('.variant-accordion-item').querySelector('.selected-text').innerText = updateSelectedItem(
        event.target.closest('.accordion-content')
      );
    });
  });

  function getItemNumber(element) {
    const itemNumber = element.closest('.variant-accordion-item').classList.value;
    return Number(itemNumber.substr(itemNumber.indexOf('item-') + 5, 1));
  }

  function updateSelectedItem(accordionContent) {
    if (accordionContent.querySelector('.colour-input') && accordionContent.querySelector('.colour-input').value) {
      return accordionContent.querySelector('.colour-input').value;
    } else if (accordionContent.querySelector('.color-palette-container .drawer-button')) {
      return accordionContent.querySelector('.color-palette-container .drawer-button > span').innerText;
    } else if (accordionContent.querySelector('input:checked')) {
      return accordionContent.querySelector('input:checked').value;
    } else if (accordionContent.querySelector('select')) {
      return accordionContent.querySelector('select').options[accordionContent.querySelector('select').selectedIndex]
        .text;
    } else if (accordionContent.querySelector('.paint-calculator-container')) {
      let text = '';
      accordionContent.querySelectorAll('.variant-details .quantity__input').forEach((quantity) => {
        if (quantity.value > 0) {
          text += `${quantity.value} x ${quantity.dataset.itemName}, `;
        }
      });
      return text.slice(0, -2);
    } else if (accordionContent.querySelector('.bundle-options')) {
      let text = '';
      accordionContent.querySelectorAll('.bundle-option.checked').forEach((option) => {
        text += `+ ${option.dataset.name}, `;
      });
      return text ? text.slice(0, -2) : 'No selection';
    }
  }
});
